import logo from "../../../assets/logo-miot.png";

import "./navbar.css";

function Navbar(props) {
    return (
        <nav className="navbar navbar-expand-lg border-bottom">
            <div className="container-fluid">
                <a className="navbar-brand" href="/">
                    Gestione ricette
                </a>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <div className="dropdown mx-3">
                            <button className="btn border dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                {props.selectedPlant}
                            </button>
                            <ul className="dropdown-menu">
                                {props.plants.map((element) => {
                                    return (
                                        <li key={element.name}>
                                            <a className="dropdown-item" onClick={() => props.setPlant(element.name)} href="#null">
                                                {element.name}
                                            </a>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                        <div className="dropdown">
                            <button className="btn border dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                Seleziona reparto
                            </button>
                            <ul className="dropdown-menu">
                                <li>
                                    <a className="dropdown-item" href="/">
                                        Reparto 1
                                    </a>
                                </li>
                                <li>
                                    <a className="dropdown-item" href="/">
                                        Reparto 2
                                    </a>
                                </li>
                                <li>
                                    <a className="dropdown-item" href="/">
                                        Reparto 3
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </ul>

                    <form className="d-flex" role="search">
                        <img src={logo} className="logo" alt="M-IoT logo" />
                    </form>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
